import React from 'react';
import PropTypes from 'prop-types';
import {NeuroMessage} from '@ignitesales/neuro-application';
import classnames from "classnames";
import {startGuide, useDispatch} from "@ignitesales/neuro-application/src/neuro-guide/state/index.mjs";
import {usePages} from "@ignitesales/neuro-application/src/neuro-guide/hooks/index.mjs";

const LandingPageStartButton = ({ className, iconAfter }) => {
    const dispatch = useDispatch();
    const { isLoadingNextPage } = usePages();
    const classes = classnames("btn", {
        [className]: !!className,
        "btn-primary": !className
    });

    return <button
        onClick={() => dispatch(startGuide('none'))}
        disabled={isLoadingNextPage}
        className={classes}
    >
        <NeuroMessage id="landing.readyToStart" />
        { iconAfter && iconAfter }
    </button>;
};
LandingPageStartButton.propTypes = {
    className: PropTypes.string
};

export default LandingPageStartButton;
